import { useSensorList } from 'services/sensor';

import useSearchAlternated from './useSearchAlternated';

/**
 *
 * @param {array} profileTypes - array of allowed profile types
 * @returns
 */
const useSearchByProfileTypes = ({
  pqlQuery,
  pqlAlternation,
  searchType,
  profileTypes,
  transformResponse, // optional transform fn
  onSearchSuccess, // optional onSuccess hook
  onSearchFail, // optional onFail hook
}) => {
  const { getActiveSensorsByProfileTypes } = useSensorList();
  const activeSensorsArray = getActiveSensorsByProfileTypes(profileTypes);
  const context = activeSensorsArray?.length > 0 ? activeSensorsArray.map((s) => s?.id).filter(Boolean) : [];

  /** force fail the hook on pqlQuery until context is defined
   * context mapping has to wait for sensor list to be fetched
   */
  return useSearchAlternated({
    pqlQuery: context && pqlQuery,
    pqlAlternation,
    searchType,
    context,
    transformResponse,
    onSearchSuccess,
    onSearchFail,
  });
};

export default useSearchByProfileTypes;
